import {PageEvent} from '@spartacus/storefront';

export class OrderConfirmationPageEvent extends PageEvent {
}
